import type { FC } from 'react';
import { Box } from '@material-ui/core';
import { ResponsiveContainer, Pie, PieChart, Cell } from 'recharts';
import Title from 'src/components/admin/Title';

interface PropsSeguimientoOficinaPie {
  dataPie: any;
}

const SeguimientoOficinaPie: FC<PropsSeguimientoOficinaPie> = ({ dataPie }) => {
  const title = 'Porcentaje de Producción Territorios';
  const RADIAN = Math.PI / 180;
  const COLORS = [
    '#1972b6',
    '#59bbfa',
    '#29c8c9',
    '#062043',
    '#d6bb74',
    '#f3883a',
    '#0e436b',
    '#007ccc',
    '#1a787a',
    '#011428',
    '#967a2b',
    '#a94c0a',
    '#298fdc',
    '#7acafa',
  ];
  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
    index,
  }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 1.2;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
    const name = dataPie[index].label;
    return (
      <text
        x={x}
        y={y}
        fill={COLORS[index]}
        textAnchor={x > cx ? 'start' : 'end'}
        dominantBaseline="central"
        style={{ fontSize: '11px', fontWeight: 'bold' }}
      >
        {`${name} ${(percent * 100).toFixed(2)}%`}
      </text>
    );
  };

  return (
    <>
      <Box pt={2}>
        <Title title={title} />
        <ResponsiveContainer aspect={2}>
          <PieChart>
            <Pie
              data={dataPie}
              dataKey="facturacion"
              label={renderCustomizedLabel}
              cx="50%"
              cy="50%"
              isAnimationActive={false}
            >
              {dataPie.map((entry, index) => {
                const key = `cell-${index}`;
                return <Cell key={key} fill={COLORS[index % COLORS.length]} />;
              })}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </Box>
    </>
  );
};

export default SeguimientoOficinaPie;
